"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Field = function (_a) {
    var label = _a.label, supportText = _a.supportText, errorText = _a.errorText, className = _a.className, error = _a.error, children = _a.children;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("ui-theme ui-field", error && 'ui-field-error', className) },
        label ? (react_1.default.createElement("label", null, label)) : null,
        children,
        errorText && (react_1.default.createElement("span", { className: "ui-field-error-text" }, errorText)),
        supportText && (react_1.default.createElement("span", { className: "ui-field-support-text" }, supportText))));
};
exports.default = Field;
